/**
 * Referral code recognition.
 *
 * Dependency-free on purpose: this is imported by the edge middleware
 * (proxy.ts) as well as by client components, so it must not pull in React or
 * analytics.
 */

/**
 * Whether a `?ref=` value is a genuine referral code rather than a marketing
 * attribution tag.
 *
 * Both share the `ref` query parameter. Referral codes are generated as 8-char
 * uppercase hex (see server/helpers/referralHelpers.js), plus a few hand-issued
 * promo codes; content CTAs across the marketing pages use hyphenated slugs
 * like `monarch-bottom` or `fire-listicle-hero`. Without this check, every
 * marketing CTA click fires a doomed referral redemption and reports a bogus
 * referral conversion.
 */
export function isReferralCode(value: string | null | undefined): boolean {
  if (!value) return false;
  return /^[A-Z0-9]{4,12}$/.test(value.trim().toUpperCase());
}
